enum RoutePath {
  INCORRECT_ROUTE = '*',
  ROOT = '/',
  SANDBOX = '/sandbox',
  IFRAME = '/iframe',
  DEMOPAGE = '/demo',
  PAY = '/pay/:enrollmentId',
  SWISH_PAY = '/swish/:enrollmentId',
  PAY_SUCCESS = '/pay-success',
  REGISTER = '/register/:activityId',
  DASHBOARD = '/dashboard',
  /** Desktop: activity list + enrollment KPIs (former Dashboard home). */
  COURSES = '/courses',
  ENROLLMENTS = '/enrollments/:clientId/:activityId',
  PROFILE = '/profile',
  INVITE = '/invite',
  EDIT_ACTIVITY = '/editActivity/:activityId',
  ACTIVITY_DETAIL = '/activity/:activityId',
  ACTIVITY_DETAIL_SEO = '/:clientSlug/activity/:activitySlug', // SEO-friendly URL with client slug
  EDIT_CLIENT = '/editClient',
  PUBLIC_ACTIVITIES = '/activities/:clientId',
  PUBLIC_ACTIVITIES_PREVIEW = '/activities-preview/:clientId',
  BAR_CODE_SCANNER = '/qrcode-scanner',
  COMMUNICATIONS_LOG = '/communications-log',
  SETTINGS = '/settings',
  SETTINGS_EMAILS = '/settings/emails',
  USER_SETTINGS = '/user-settings',
  ALLCUSTOMERS = '/all-customers',
  COMMUNICATION = '/communication',
  CHECKIN = '/checkin/:enrollmentId/:activityId?',
  FEATURES = '/_features',
  TEST = '/TEST',
  NO_ACCESS_PAGE = '/no-access',
  LIMBO_STATE_PAGE = '/limbo-state',
  REGISTER_OBFUSCATED = '/register/:activityId/:enrollmentId',
  REGISTER_SEO = '/:clientSlug/register/:activitySlug', // SEO-friendly URL with client slug
  ACTIVITY_IFRAME_CONFIGURATOR = '/iframe-configurator',
  FINANCIALS = '/activityFinancials',
  FINANCIALS_DETAILS = '/financialsDetails',
  FINANCIALS_OVERVIEW = '/financialsOverview',
  FINANCIALS_OVERVIEW_REPORT = '/financials-overview-report',
  FINANCIALS_PAYMENTS = '/financialsPayments',
  FINANCIALS_PAYMENT_TRANSACTIONS = '/financials-payment-transactions',
  FINANCIALS_PAYMENT_TRANSACTIONS_OTHER = '/financials-payment-transactions-other',
  FINANCIALS_TRANSACTIONS = '/financials-transactions',
  ENROLLMENT_DETAIL = '/enrollment/:enrollmentId',
  ENROLLMENT_DETAILS = '/enrollment-details/:enrollmentId',
  USER_DETAILS = '/user-details/:enrollmentUserId',
  URL_SHORT_REDIRECT = '/r/:hash', // see: UrlHelper.getUrlShort() pattern,
  LOGOUT = '/logout',
  DASHBOARD_MOBILE = '/dashboard-mobile',
  CUSTOMERS_MOBILE = '/customers',
  CALENDAR_MOBILE = '/calendar-mobile',
  ADMIN_SETTINGS = '/admin-settings',
  ADMIN_SEND_EMAILS_MOBILE = '/admin-send-emails',
  ADMIN_STATISTICS_MOBILE = '/admin-statistics',
  SUPER_ADMIN = '/super-admin',
  SUPER_ADMIN_PERMISSIONS = '/super-admin/permissions',
  SUPER_ADMIN_METRICS = '/super-admin/metrics',
  SUPER_ADMIN_ORGANIZATIONS = '/super-admin/organizations',
  SUPER_ADMIN_CONFIGURATIONS = '/super-admin/configurations',
  SUPER_ADMIN_SUBSCRIPTIONS = '/super-admin/subscriptions',
  SUPER_ADMIN_UPCOMING_ACTIVITIES = '/super-admin/upcoming-activities',
  SUPER_ADMIN_TROUBLESHOOTING = '/super-admin/troubleshooting',
  SUPER_ADMIN_ACTIONS = '/super-admin/actions',
  SUPER_ADMIN_DATABASE_TOOLS = '/super-admin/database-tools',
  SUPER_ADMIN_ENROLLMENT_YOY = '/super-admin/enrollment-yoy',
  SUPER_ADMIN_RESET_TEST_CLIENTS = '/super-admin/reset-test-clients',
  SUPER_ADMIN_DESIGN_SYSTEM = '/super-admin/design-system',
  ADMIN_DOCS = '/admin-docs',
  CHECKOUT = '/checkout/:clientId/:productType',
  DROPIN_TICKETS = '/dropin-tickets',
  DROPIN_TICKET_DETAIL = '/dropins/:enrollmentUserId/:dropinTicketId',
  PRIVATE_LESSONS = '/private-lessons',
  ROOM_MANAGEMENT = '/room-management',
  PRIVATE_LESSONS_CHECKOUT = '/privateLessons/:clientId',
  PRIVATE_LESSON_ORDER = '/private-lesson-order/:clientId/:orderId',
  PRIVATE_LESSONS_PORTAL = '/privateLessons/portal/:registerToken',
  PORTAL_LOGIN = '/portal/login',
  PORTAL_VIEW_AS = '/portal/view-as/:ticketId',
  PORTAL_VIEW_AS_ENDED = '/portal/view-as-ended',
  PORTAL = '/portal',
  PORTAL_DASHBOARD = '/portal/dashboard',
  PORTAL_HOME = '/portal/home',
  PORTAL_HOME_ORDERS = '/portal/home/orders',
  PORTAL_HOME_ORDER_RECEIPT = '/portal/home/orders/:orderId',
  PORTAL_HOME_OCCASIONS = '/portal/home/occasions',
  PORTAL_LOGOUT = '/portal/logout',
  PORTAL_PRIVATE_LESSONS = '/portal/private-lessons',
  PORTAL_DROPIN_TICKETS = '/portal/dropin-tickets',
  PORTAL_DROPIN_TICKET_DETAIL = '/portal/dropin-tickets/:dropinTicketId',
  PORTAL_WALKIN_TICKETS = '/portal/walkin-tickets',
  PORTAL_WALKIN_TICKET_DETAIL = '/portal/walkin-tickets/:paymentRef',
  PORTAL_ENROLLMENTS = '/portal/enrollments',
  PORTAL_ENROLLMENT_DETAIL = '/portal/enrollments/:enrollmentId',
  PORTAL_PROFILE = '/portal/profile',
  APP_LOGS = '/app-logs',
  FORTNOX_TRANSACTIONS = '/fortnox-transactions',
  SEB_TRANSACTIONS = '/seb-transactions',
  RELEASE_NOTES = '/release-notes',
  RECEPTION_APP = '/reception-app',
  WALK_IN_SESSIONS = '/walk-in-sessions',
  /** Admin: today’s check-in schedule (same rules as Reception / check-in tooling) */
  CHECKIN_APP_OPERATIONS = '/checkin-app-operations',
  /** Printable QR poster: user-web checkout for drop-in packages */
  PRINT_QR_DROPIN_TICKETS = '/print-qr/dropin-tickets',
  /** Printable QR poster: customer portal login */
  PRINT_QR_PORTAL_LOGIN = '/print-qr/portal-login',
  /** Printable QR poster: registration page for a specific activity */
  PRINT_QR_ACTIVITY_REGISTRATION = '/print-qr/activity-registration/:activityId'
}

export default RoutePath
